import React, { Component } from 'react'
import injectSheet from 'react-jss'
import { StripeProvider, Elements } from 'react-stripe-elements'
import { flexUtils } from '../../../Theme/Theme'
import ChangeCardForm from './ChangeCardForm'
// import ReactGA from 'react-ga'

class EditPaymentMethod extends Component {
    render() {
        const { classes} = this.props
        const { Body } = classes
        return (
            <div className={Body}>
                <StripeProvider apiKey="pk_live_aSbECe1iQCa0XmDx2UzPgmZF">
                    <Elements>
                        <ChangeCardForm onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                    </Elements>
                </StripeProvider>
            </div>
        )
    }

    componentDidMount () {
        // ReactGA.pageview('/Home/EditPaymentMethod');
    }           

    onCancel = () => {
        this.props.history.push('/Home/AccountInfo')
    }

    onSubmit = (token) => {
        // console.log(token)
        this.props.history.push('/Home/AccountInfo')
    }
}

const styles = {
    ...flexUtils,
    Body: {
        paddingTop: '1rem',
        composes: ['$FlexColumn'],
        justifyContent: 'flex-start',
        flex: '1',
        width: '100%',
        maxWidth: '36rem'
    }
}

export default injectSheet(styles)(EditPaymentMethod)



// WEBPACK FOOTER //
// ./src/js/Components/Home/Settings/EditPaymentMethod.jsx